/* template */
<template minapp="mpx" xlang="wxml"><es-popup :closeable="(false)" :show="(show)"><div class="contact-dialog" v-if="(show)"><slot name="icon"></slot><div><div class="contact-dialog-title">{{title}}</div><div class="contact-dialog-subtitle">{{subTitle}}</div><div class="contact-dialog-slot"><slot></slot></div><div class="contact-dialog-content" v-if="(content)">{{content}}</div></div><div :class='("contact-dialog-btns "+(cancelText && confirmText ? "two-btn" : "one-btn"))'><mpx-view @tap="cancelTap" class="contact-dialog-cancel" v-if="(cancelText)">{{cancelText}}</mpx-view><mpx-view @tap="confirmTap" class="contact-dialog-confirm" v-if="(confirmText)">{{confirmText}}</mpx-view></div></div></es-popup></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"md3416d8a"}'>
  .contact-dialog
    display flex
    flex-direction column
    justify-content space-between
    padding-top 24px
    box-sizing border-box
    width 280px
    min-height 190px
    border-radius 12px
    background linear-gradient(175deg, #D9EBFF 3%, #FFFFFF 26%), #FFFFFF
    &-title
      padding 0 24px
      font-size 20px
      font-weight 400
      line-height 24px
      text-align center
      color #000
      font-family PingFangSC-Medium
    &-subtitle 
      padding 0 24px
      font-size 16px
      font-weight 400
      line-height 18px
      text-align center
      color #000
      margin-top 12px
      font-family PingFangSC-Medium
    &-slot
      padding 0 24px
    &-content
      padding 0 24px
      margin 24px auto
      line-height 22px
      color #212121
      font-size 16px
      font-family PingFangSC-Regular
    &-btns
      display flex
      justify-content space-between
      &.one-btn
        height 50px
        line-height 50px
        color #1473FF
        border-top 1px solid #F3F4F5
        &.one-btn .contact-dialog-cancel,&.one-btn .contact-dialog-confirm
          padding 0
          border 0
      &.two-btn
        margin 0 24px 24px 24px
        color #1473FF
    &-confirm
      margin-left 12px
    &-cancel,&-confirm
      flex 1
      text-align center
      padding 11px
      border-radius 8px
      border 1px solid #1473FF
  
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "md3416d8a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexd3416d8a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexd3416d8a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["md3416d8a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexd3416d8a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
